// Ofrece el selector "Elegí qué agregar" a las cards de la conversación, para sumar
// referencias a una card de imagen (ADR-2026-10-20-las-referencias-de-la-card-se-editan).
// Lo elegido NO va al chat: va a la card que lo pidió, de a uno.

import React, { useCallback, useRef, useState } from 'react';
import type { ChatAttachment } from '../../pages/v2/agentAttachments';
import { SelectorDeReferenciasContext } from '../../pages/v2/selectorDeReferenciasDeLaCard';
import { ModalDeFuentes } from './ModalDeFuentes';

export const ProveedorDeSelectorDeReferencias: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [abierto, setAbierto] = useState(false);
  const destino = useRef<((a: ChatAttachment) => void) | null>(null);
  const abrir = useCallback((onElegido: (a: ChatAttachment) => void) => {
    destino.current = onElegido;
    setAbierto(true);
  }, []);
  return (
    <SelectorDeReferenciasContext.Provider value={abrir}>
      {children}
      <ModalDeFuentes
        abierto={abierto}
        onCerrar={() => {
          setAbierto(false);
          destino.current = null;
        }}
        onAdjuntar={(a) => destino.current?.(a)}
        multiple
        pestanaInicial="subidas"
      />
    </SelectorDeReferenciasContext.Provider>
  );
};
